export class ProviderGroup {
    public static values = [

    ];


    public static valuesFormB = [
        "Assisted Living Facilities",
        "Body Art Establishment",
        "Home Care and Home Health Agencies",
        "Mortuary Science"
        /*
        "Speech-Language Pathology and Audiologist Program",
        "Birth Centers",
        "Out-Patient Surgery",
        "Board & Care Home",
        "Supplemental Nursing Services Agency",
        "Board and Lodging Special Services",
        "Outpatient Surgery Center",
        "Nurse Aide Training Sites",
        "Nurse Aide Testing Sites",
        "Hospices",
        "Supervised Living Facility or B&L",
        "Mobile Health Evaluation & Screening",
        "Nursing Homes",
        "End Stage Renal Dialysis",
        "Supervised Living Facility",
        "Hospital",
         */
    ].sort();
}